import { Navigate, Outlet } from 'react-router-dom'
import { useSessionInfo } from '../../contexts/SessionContext'

const ProtectedRoutes = () => {
  const { session } = useSessionInfo()

  if (!session?.user?.id) {
    return <Navigate to='/' replace />
  }

  return <Outlet />
}

export default ProtectedRoutes
